/**
 * ...
 * @author Robert Lombardo, Wakefield Studios ( rob@wakefield-studios.com )
 */
module.exports = {
    tag: 'glorious',
    quality: 0.7,
    mana: 1,
    strength: 3,
    willpower: 3
}